<template>
<div class="address_container">
 <!-- <div class="header_container">
  <h3>{{ $t('editAddAddress') }}</h3>
 </div> -->
  <el-tabs v-model="activeName">
    <el-tab-pane :label="$t('addressRegistration')" name="second">
      <ul class="address-container" v-if="addresses.length > 0">
        <li v-for="(address, index) in addresses" :key="index">
          <span class="addressDisplay">{{ address.Street }}</span>
          <span>{{ address.City + ', ' + address.State + ' ' + address.Zip}}</span>
          <span class="deleteBtn" @click="editAddressModalOpen(address)"><i class="el-icon-edit"></i></span>
          <span class='editBtn' @click="openConfirmationDeleteAlert(address.CustomerDetail_id)"><i class="el-icon-delete"></i></span>
        </li>
      </ul>
    </el-tab-pane>
    <el-tab-pane :label="$t('addNewAddress')" name="third">
      <div v-if="errorSubmitting" class="time_tip"><span>{{ $t('correctErrors') }}</span></div>
      <el-form ref="addressForm" :rules="rules" :model="addressForm">
        <el-form-item prop="FirstName">
          <el-input v-bind:placeholder="$t('firstName')" v-model="addressForm.FirstName"></el-input>
        </el-form-item>
        <el-form-item prop="LastName">
          <el-input v-bind:placeholder="$t('lastName')" v-model="addressForm.LastName"></el-input>
        </el-form-item>
        <el-form-item prop="Address">
          <el-input v-bind:placeholder="$t('addressIncludingApt')" v-model="addressForm.Address"></el-input>
        </el-form-item>
        <el-form-item prop="Telephone">
          <el-input v-bind:placeholder="$t('mobilePhone')" v-model="addressForm.Telephone"></el-input>
        </el-form-item>
        <el-form-item prop="City">
          <el-input v-bind:placeholder="$t('city')" v-model="addressForm.City"></el-input>
        </el-form-item>
        <el-form-item prop="Country">
          <el-select v-model="addressForm.Country" value="">
            <el-option v-for="item in CountryList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="State">
          <el-select v-model="addressForm.State" v-bind:placeholder="$t('pleaseSelect')" value="">
            <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="Zip">
          <el-input v-bind:placeholder="$t('zipCode')" v-model="addressForm.Zip"></el-input>
        </el-form-item>
        <div class="btnBox">
          <button class="btn" @click="handleClose($event)">清空</button>
          <button class="btn" :class="submitting? 'greybackground' : ''" @click="onSubmit($event, addressForm)">{{ $t('confirm') }}</button>
        </div>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import {
 mapState,
 mapActions,
 mapMutations
} from 'vuex'
import {
 MessageBox
} from 'element-ui';
export default {
 name: 'account-address',
 data() {
  return {
   activeName:'second',
   errorSubmitting: false,
   submitting: false,
   addressForm: {
    FirstName: '', //名字
    LastName: '', //名字
    Address: '', //地址
    apartment: '', //地址
    City: '', //城市
    Zip: '', //编码
    Telephone: '', //联系方式
    Country: 'United States', //国家/地区
    State: 'CA', //地区
   },
   CountryList: [{
    value: '',
    label: '---'
   }, {
    value: 'United States',
    label: 'United States'
   }],
   stateOptions: this.$store.state.addresses.states,
  }
 },
  // computed: {
  computed: mapState({
    addresses: state => state.addresses.customerDetails,
    rules(){
      return {
        FirstName: [{
            required: true,
            message: this.$t('firstNameRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 20,
            message: this.$t('firstNameLengthRequired'),
            trigger: 'blur'
          }
        ],
        LastName: [{
            required: true,
            message: this.$t('lastNameRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 20,
            message: this.$t('lastNameLengthRequired'),
            trigger: 'blur'
          }
        ],
        Address: [{
            required: true,
            message: this.$t('addressRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 30,
            message: this.$t('addressNumberLengthRequired'),
            trigger: 'blur'
          }
          ],
        apartment: [{
            required: false,
            message: '',
            trigger: 'blur'
          },
          {
            min: 3,
            max: 10,
            message: this.$t('apartmentNumberLengthRequired'),
            trigger: 'blur'
          }
        ],
        City: [{
            required: true,
            message: this.$t('cityRequired'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 20,
            message: this.$t('cityLengthRequired'),
            trigger: 'blur'
          }
        ],
        Zip: [{
            required: true,
            message: this.$t('zipCodeRequired'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 5,
            message: this.$t('zipCodeLengthRequired'),
            trigger: 'blur'
          }
        ],
        Telephone: [{
            required: true,
            message: this.$t('phoneNumberRequired'),
            trigger: 'blur'
          },
          {
            min: 10,
            max: 12,
            message: this.$t('phoneNumberLengthRequired'),
            trigger: 'blur',
          }
        ],
        Country: [{
            required: true,
            message: this.$t('countryRequired'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 20,
            message: this.$t('countryLengthRequired'),
            trigger: 'blur'
          }
        ],
      }
    }
  }),
 methods: {
  ...mapActions('addresses', ['fetchAddresses', 'postAddress', 'deleteAddress', 'editAddress']),
  resetForm() {
   this.addressForm = {
    FirstName: '', //名字
    LastName: '', //名字
    Address: '', //地址
    apartment: '', //地址
    City: '', //城市
    Zip: '', //编码
    Telephone: '', //联系方式
    Country: 'United States', //国家/地区
    State: 'CA', //地区
   }
  },
  openAlert() {
   this.$alert('You have successfully added a new address', 'Success', {
    confirmButtonText: 'OK',
    type: 'success',
    center: true
   }).then(() => {
   }).catch(() => {});
  },
  openEditSuccessAlert() {
   this.$alert('An address has been modified', 'Success', {
    confirmButtonText: 'OK',
    type: 'success',
    center: true
   }).then(() => {
   }).catch(() => {});
  },
  openConfirmationDeleteAlert(id) {
   MessageBox.confirm('Remove this address from the list?', 'Warning', {
    confirmButtonText: 'OK',
    cancelButtonText: 'CALCEL',
    type: 'warning',
    center: true
   }).then(() => {
    this.deleteAddress(id);
   }).catch(() => {});
  },
  handleClose(event) {
   event.preventDefault();
   this.resetForm
   this.$refs['addressForm'].resetFields();
  },
  onSubmit(event, form) {
   if (this.submitting) {
    return;
   }
   event.preventDefault();
   this.$refs['addressForm'].validate((valid) => {
    if (!valid) {
     return;
    } else {
     const address = {
      ...form,
      Street: form.Address + ',' + form.apartment,
     };
     this.submitting = true
     if (address.CustomerDetail_id) {
      this.editAddress([address, address.CustomerDetail_id])
       .then(res => {
        this.openEditSuccessAlert();
        this.fetchAddresses();
        this.submitting = false;
       })
       .catch(err => {
        alerrt(err)
       })
     } else {
      this.postAddress(address)
       .then((res) => {
        this.openAlert();
        this.resetForm();
        this.submitting = false;
        this.$refs['addressForm'].clearValidate();
        this.fetchAddresses();
       })
       .catch(err => {
        alert(err);
       })
     }
    }
   });
  },
  editAddressModalOpen(address) {
   const newAddress = {
    ...address,
    Address: address.Street.split(',')[0],
    apartment: address.Street.split(',')[1],
   }
   this.addressForm = newAddress;
   this.$refs['addressForm'] && this.$refs['addressForm'].clearValidate();
   this.activeName = 'third'
  },
  newAddressAdd() {
   this.resetForm();
   this.$refs['addressForm'] && this.$refs['addressForm'].clearValidate();
  }
 },
 mounted() {
  this.fetchAddresses();
 },
//  computed: mapState({
//   addresses: state => state.addresses.customerDetails
//  }),
}
</script>

<style lang="less">
.address_container {

 .el-tabs{
    .el-tabs__header{
      .el-tabs__nav-wrap{
        .el-tabs__nav{
          .el-tabs__active-bar{
            background-color: #EB6A42;
          }
          .is-active{
            color: #EB6A42;
          }
        }
      }
    }
  }

  .address-container {
    li {
      display: block;
      line-height: 30px;
      background-color: #E9E9E9;
      border-radius: 5px;
      padding: 20px;
      margin-bottom: 10px;
      .deleteBtn {
        float: right;
      }
      .editBtn {
        float: right;
      }
      i {
        font-size: 20px;
        padding: 5px;
        cursor: pointer;
      }
      i:hover {
        color: #f5a623;
        // background: #f5a623;
        // background-color: red;
      }
    }
  }
  .el-form{
    max-width: 600px;
    padding-bottom: 20px;
    .el-input{
      .el-input__inner{
        background-color: #fff;
        border: 1px solid #E8E8E8;
      }
    }
    .btnBox{
      display: flex;
      justify-content: flex-end;
    }
  }



  .btn {
    cursor: pointer;
    width: 100px;
    margin-left: 30px;
    background-color: #ff6f37;
    background-clip: border-box;
    box-sizing: border-box;
    border: 1px transparent solid;
    border-radius: 5px;
    color: white;
    font-weight: 500;
    padding: 15px;
    text-align: center;
    position: relative;
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  }

 .header_container {
  border-bottom: 1px solid silver;
  padding-bottom: 12px;
 }


 .modal {
  margin-top: 100px;
 }

 button {
  outline: none;
 }

 .time_tip {
  color: #f5a623;
  font-size: 12px;
 }
 .greybackground {
  background-color: grey !important;
 }
}

@media only screen and (max-width: 490px) {
  .address_container {
    .el-tabs{
      .el-tabs__header{
        .el-tabs__nav-wrap{
          .el-tabs__nav{
            .el-tabs__active-bar{
              background-color: #EB6A42;
            }
            .is-active{
              color: #EB6A42;
            }
            .el-tabs__item{
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Profile/address.vue